import { FilterConfigFixed } from '@/types/filter';
import Stars from '@/components/shared/rating/Stars/Stars';
import { HCP_SCIENTIFIC_ACTIVITY_AUTHOR } from '@/api/hcp';
import { FilterValue } from '../../FilterType';

const publicationFilter: FilterConfigFixed = {
  label: 'global.filters.formControls.publicationLabel',
  placeholder: 'global.filters.formControls.publicationPlaceholder',
  defaultValue: null,
  type: 'levelselect',
  format: ({ value, t }) => (
    <>
      <span>{t('global.filters.publication')}</span>
      <Stars value={parseInt(value.toString())} />
    </>
  ),
  filterGroup: 'scientificActivities',
  applyFilter: (filterValue: FilterValue) => {
    const ratingScore = Number(filterValue) || 0;

    return {
      and: [
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_AUTHOR}.score_label`,
          operator: 'equals',
          values: ['national score'],
        },
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_AUTHOR}.score_value`,
          operator: 'gte',
          values: [ratingScore.toString()],
        },
      ],
    };
  },
};

export default publicationFilter;
